import { isFirefox } from "./is_firefox";
import { isSafari } from "./is_safari";

const testSupportsSmoothScroll = (): boolean => {
  let isSupported = false;
  try {
    const div = document.createElement("div");
    div.scrollTo({
      top: 0,
      get behavior(): ScrollBehavior {
        isSupported = true;
        return "smooth";
      }
    });
  } catch {
    isSupported = false;
  }
  return isSupported;
};

export const scrollTo = (element: Element | Window, left: number, top: number): void => {
  const supportsSmooth = testSupportsSmoothScroll();

  if (!element) {
    return;
  } // just in case;

  const elementStyleHasOverflowHidden = getComputedStyle(
    ((element as Window).window === window ? document.body : element) as Element
  ).overflow.includes("hidden");

  /*
    there's a bug in WebKit which causes smooth scroll on elements which have overflow hidden to not work
    https://bugs.webkit.org/show_bug.cgi?id=238497#c18
    the same seems true for firefox
   */
  if (supportsSmooth && !((isSafari() || isFirefox()) && elementStyleHasOverflowHidden)) {
    element.scrollTo({ behavior: "smooth", left, top });
  } else {
    element.scrollTo(left, top);
    // ie or safari most likely -> no animation
  }
};
